/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const auth: Readonly<Record<string, string>> = {
  // Sign in
  "Enter your email address first, then choose Forgot password.":
    "Primero hay que escribir el email y luego elegir Olvidé mi contraseña.",
  "Check your email": "Revisar el email",
  "If an account exists for {email}, a link to set a new password is on its way. It expires in an hour.":
    "Si existe una cuenta para {email}, va en camino un enlace para crear una nueva contraseña. Caduca en una hora.",
  "Back to sign in": "Volver a iniciar sesión",
  Email: "Email",
  Password: "Contraseña",
  "Signing in…": "Iniciando sesión…",
  "Sign in": "Iniciar sesión",
  "Forgot password?": "¿Olvidé mi contraseña?",

  // Choosing or resetting a password
  "Use at least {n} characters.": "Usar al menos {n} caracteres.",
  "The two passwords do not match.": "Las dos contraseñas no coinciden.",
  "Choose a password": "Elegir una contraseña",
  "Set a new password": "Crear una nueva contraseña",
  "Welcome. Pick a password and you are in — you will use it to sign in from now on.":
    "Bienvenido. Con una contraseña queda todo listo — servirá para iniciar sesión de ahora en adelante.",
  "Pick a new password. This replaces the old one everywhere you are signed in.":
    "Nueva contraseña. Reemplaza la anterior en todos los dispositivos con sesión iniciada.",
  "New password": "Nueva contraseña",
  "Confirm password": "Confirmar contraseña",
  "Save password": "Guardar contraseña",
};
